<template>
    <a-card>
        <div style="text-align:center;margin-bottom:20px;">
          
            <h2>刻章备案登记</h2>
            <span v-if="form.remark" style="color:#ff4d4f;font-size:20px">审核未通过：{{form.remark}}</span>
        </div>
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">

                
                <a-col :span="24">
                    <a-form-item style="position:relative" label="是否为新办市场主体" name="isMarket">
                            <a-radio-group v-model:value="form.isMarket" name="radioGroup">
                                <a-radio :value="0">否</a-radio>
                                <a-radio :value="1">是</a-radio>
                            </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item style="position:relative" label="是否个转企" name="isEnterprise">
                            <a-radio-group v-model:value="form.isEnterprise" name="radioGroup">
                                <a-radio :value="0">否</a-radio>
                                <a-radio :value="1">是</a-radio>
                            </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                <div class="filePost">
                    <h3>附件提供</h3>
                </div>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="营业执照正/副本复印件(PDF,IMG格式)及原件电子版照片（PDF,IMG格式）" name="businessLicense">
                        <file-upload v-model:value="form.businessLicense" :size="800" :isPdfImg="true"  />
                    </a-form-item>
                    <a-form-item label="法人身份证复印件(正反面复印在一张纸上，PDF,IMG格式)
                    及正反电子版照片（PDF,IMG格式）" name="legalPersonCard">
                        <file-upload v-model:value="form.legalPersonCard" :size="800" :isPdfImg="true"  />
                    </a-form-item>
                    <a-form-item label="经办人身份证复印件(正反面复印在一张纸上，PDF格
                    式)及正反电子版照片（PDF,IMG格式）" name="agentCardFile">
                        <file-upload v-model:value="form.agentCardFile" :size="800" :isPdfImg="true"  />
                    </a-form-item>
                    <a-form-item label="法人半身照（PDF,IMG格式）" name="legalPersonPhoto">
                        <file-upload v-model:value="form.legalPersonPhoto" :size="800" :isPdfImg="true"  />
                    </a-form-item>
                    <a-form-item label="经办人半身照（PDF,IMG格式）" name="agentPhoto">
                        <file-upload v-model:value="form.agentPhoto" :size="800" :isPdfImg="true"  />
                    </a-form-item>

                    <!-- <a-form-item label="印章刻章流转单：经办人自备委托书由法人签字并按手印
                    或直接加盖法人章(PDF,IMG格式)" name="circulationOrder">

                        <file-upload style="float:left;margin-right:20px;"  v-model:value="form.circulationOrder" :size="800" :isPdfImg="true"  />
                        <a-button style="background: #a8a8a8;border:1px solid #a8a8a8" type="primary" @click="exportExcelTemplate0">
                            印章刻章流转单模板下载
                        </a-button>
                    </a-form-item> -->
                    <a-form-item label="刻章备案登记表：经办人自备委托书由法人签字并按手印
                    或直接加盖法人章(PDF,IMG格式)" name="registrationForm">

                        <file-upload style="float:left;margin-right:20px;"  v-model:value="form.registrationForm" :size="800" :isPdfImg="true"  />
                        <a-button style="background: #a8a8a8;border:1px solid #a8a8a8" type="primary" @click="exportExcelTemplate1">
                            刻章备案登记表模板下载
                        </a-button>
                    </a-form-item>
                    <!-- <a-form-item label="授权委托书：经办人自备委托书由法人签字并按手印
                    或直接加盖法人章(PDF,IMG格式)" name="powerOfAttorney">

                        <file-upload style="float:left;margin-right:20px;"  v-model:value="form.powerOfAttorney" :size="800" :isPdfImg="true"  />
                        <a-button style="background: #a8a8a8;border:1px solid #a8a8a8" type="primary" @click="exportExcelTemplate2">
                            授权委托书模板下载
                        </a-button>
                    </a-form-item> -->
                </a-col>
                <!--可编辑区域 end-->
                <a-col :span="24" style="text-align: center;">
                    <a-button style="margin-right:20px" type="primary" html-type="submit" @click="onSubmit">
                        保存
                    </a-button>
                    <a-button style="margin-right:20px" type="primary" @click="isSubmit">
                        保存并提交
                    </a-button>
                    <a-button type="primary" @click="back">
                        返回
                    </a-button>
                </a-col>
            </a-row>
        </a-form>
    </a-card>
</template>
<script>
import { file_service } from "@/api/adminService";
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {enterpriseEngraveApply} from "@/api/EnterpriseSealService";
import {SealService} from "@/config/variableConfig";
import {postAction,postJson} from "@/utils/http/service";
import {filterObj} from "@/utils/util";

const columns = [
  {
    dataIndex: 'sealType',
    width: 130,
    slots: { title: 'customTitle1', customRender: 'sealType' },
  },
  {
    dataIndex: 'topContent',
    slots: { title: 'customTitle2', customRender: 'topContent' },
  },
  {
    dataIndex: 'middleBottomContent',
    slots: { title: 'customTitle3', customRender: 'middleBottomContent' },
  },
  {
    dataIndex: 'materialType',
    width: 120,
    slots: { title: 'customTitle4', customRender: 'materialType' },
  },
  {
    dataIndex: 'specifications',
    slots: { title: 'customTitle5', customRender: 'specifications' },
  },
  {
    dataIndex: 'sealRemark',
    slots: { title: 'customTitle6', customRender: 'sealRemark' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    fixed: 'right',
    width: 65,
    slots: { customRender: 'operation' },
  },
];
export default {
    name: "AddOrEditModal",
    components: {
    },

    mixins: [formMixin],
    data() {
        return {
            SealService,
            columns,
            form: {
                    id: null,
                    reason: 0, //原因
                    enterpriseSealInfos: [],
                    collectionMethod: 0,
                    isMarket : 0, //是否为新办市场主体
                    isEnterprise : 0, //是否个转企
                    mailingAddress: null,
                    agent: null,
                    agentPhone: null,
                    isSubmit: 0,
                    schedule: 0,
                    authPeriod: null,
                    agentIdCard: null,
                    businessLicense: null,
                    legalPersonCard: null,
                    agentCardFile: null,
                    legalPersonPhoto: null,
                    agentPhoto: null,
                    // circulationOrder: null,
                    registrationForm: null,
                    // powerOfAttorney: null,
            },
             editableData: {},
            rules: {
                    id: [],
                    reason: [],
                    collectionMethod: [dataCheck.required({ type: 'number'})],
                    enterpriseSealInfos: [dataCheck.required({ type: 'array' })],
                    mailingAddress: [dataCheck.required({})],
                    agent: [dataCheck.required({})],
                    agentPhone: [dataCheck.required({}),dataCheck.phone],
                    authPeriod: [dataCheck.required({})],
                    isSubmit: [],
                    schedule: [],
                    agentIdCard: [dataCheck.required({}),dataCheck.id_num],
                    businessLicense: [dataCheck.required({})],
                    legalPersonCard: [dataCheck.required({})],
                    agentCardFile: [dataCheck.required({})],
                    legalPersonPhoto: [dataCheck.required({})],
                    agentPhoto: [dataCheck.required({})],
                    // circulationOrder: [dataCheck.required({})],
                    registrationForm: [dataCheck.required({})],
                    // powerOfAttorney: [dataCheck.required({})],
                    
            },

            options: [],
            submitType: 'json'

        }
    },
    
    computed: {
            submitUrl() {
                    return enterpriseEngraveApply.saveOrUpdate
            }
        },
    mounted() {
      console.log(this.$route.query.id)
      if(this.$route.query.id){
        this.getFormData()
      }
    },
    methods: {
      
        exportExcelTemplate0() {
            this.getAction({
                url: enterpriseEngraveApply.querySeal0,
            }).then(res=>{
              const link = document.createElement("a"); // 创建a标签
              link.href =  file_service.download + res;
              link.target = '_blank';
              link.click();
            })
        },
        exportExcelTemplate1() {
            this.getAction({
                url: enterpriseEngraveApply.querySeal1,
            }).then(res=>{
              const link = document.createElement("a"); // 创建a标签
              link.href =  file_service.download + res;
              link.target = '_blank';
              link.click();
            })
        },
        exportExcelTemplate2() {
            this.getAction({
                url: enterpriseEngraveApply.querySeal2,
            }).then(res=>{
              const link = document.createElement("a"); // 创建a标签
              link.href =  file_service.download + res;
              link.target = '_blank';
              link.click();
            })
        },
      isSubmit(){
        this.form.schedule = 0
        this.form.isSubmit = 1
        this.onSubmit();
      },
      back(){
        this.$router.push({path: '/sys/EnterpriseSealService'})
      },
      /*提交表单操作*/
      onSubmit() {
            if(this.$route.query.id){
                this.form.id = this.$route.query.id
            }
            // const isAgeEmpty = this.form.enterpriseSealInfos.some(item => item.sealType === undefined || item.sealType === null || item.sealType === '' || item.topContent === undefined || item.topContent === null || item.topContent === '' || item.middleBottomContent === undefined || item.middleBottomContent === null || item.middleBottomContent === '' || item.materialType === undefined || item.materialType === null || item.materialType === '' || item.specifications === undefined || item.specifications === null || item.specifications === '');
            const isAgeEmpty = false
                            if(isAgeEmpty){
                                this.$notification.warning({
                                    message: '提示',
                                    description: '您的印章选择有未填项，请删除多余项！',
                                });
                              }else{
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                           
                            setTimeout(() => {
                              
                                this.$router.push("/sys/EnterpriseSealService")
                            }, 500);
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                                
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                        }
                        window.console.log('error', error);
                    });
            }
          }
        },
      getFormData(){
        this.getAction({
                url: enterpriseEngraveApply.detail,
                params: {id: this.$route.query.id}
            }).then((res) => {
              this.form = res
            })
      },
        smesChange(n){
            this.$refs.ruleForm.resetFields(n)
            if(this.form.collectionMethod==0){
                this.form.mailingAddress = ''
            }                                      
        },
        handleAdd() {
        const newData = {
            key: this.form.enterpriseSealInfos ? this.form.enterpriseSealInfos.length : 1,
            sealType: undefined,
            topContent: undefined,
            middleBottomContent: undefined,
            materialType: undefined,
            specifications: undefined,
            sealRemark: undefined
        };
        // console.log('enterpriseSealInfos', this.form.enterpriseSealInfos)
        this.form.enterpriseSealInfos.push(newData);
        },
        deleteLine(key) {
        this.form.enterpriseSealInfos = this.form.enterpriseSealInfos.filter(item => item.key !== key);
        },
        saveEdit(key) {
        Object.assign(this.form.enterpriseSealInfos.filter(item => key === item.key)[0], this.editableData[key]);
        
        
        const itemName = 'sealType';
        const isItemRepeated = this.form.enterpriseSealInfos.reduce((acc, obj, index, array) => {
          const isRepeated = array.findIndex((item, i) => item[itemName] === obj[itemName] && i !== index) !== -1;
          return acc || isRepeated;
        }, false);
        if(isItemRepeated){
          this.deleteLine(key)
          this.$notification.warning({
              message: '提示',
              description: '该类型已添加！',
          });
          setTimeout(() => {
           this.handleAdd()
          }, 100);
        }
        
        },
    },
}
</script>
<style scoped lang="less">
.filePost{
  margin-bottom: 20px;
  h3{
    line-height: 25px;
    padding-left:15px;
    border-left: 4px solid #09b1ff;
  }
}
/*
:deep(.img-upload){
    width:200px;
    height:120px;
}
:deep(.ant-upload-list) {
    position: absolute;
    top:0;
    left:220px;
}
:deep(.ant-upload-list-picture-card-container){
    width:200px;
    height:120px;
}

:deep(.ant-upload-list-item){
    width:200px;
    height:120px;
}
*/
:deep(.ant-table-scroll table){
  min-height: 170px;
}
</style>
